import TipoActivoService from 'src/modules/tipoActivo/tipoActivoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TIPOACTIVO_VIEW';

const tipoActivoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoActivoViewActions.FIND_STARTED,
      });

      const record = await TipoActivoService.find(id);

      dispatch({
        type: tipoActivoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoActivoViewActions.FIND_ERROR,
      });

      getHistory().push('/tipo-activo');
    }
  },
};

export default tipoActivoViewActions;
